<!-- CARGADOR -->
<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Edición de apartados</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <!-- TABLA GRID -->
    <div class="container" style="display: flex; gap: 2%; margin-top: 20px; margin-left: 10px; position:relative; ">

        <div class="col-3">
            <h5>Menú maestro</h5>
            <jqxTree #menu [theme]="environment.tema" [width]="'100%'" [height]="485" [source]="recordsMenu"
                [hasThreeStates]="false" [checkboxes]="false" (onSelect)="onSelectMenu($event)">
            </jqxTree>
        </div>

        <div *ngIf="opcionSelec" class="col-6">
            <h5>Apartados de {{opcionTexto}}</h5>
            <jqxGrid #gridApartados [theme]="environment.tema" [width]="'100%'" [height]="445"
                [source]="dataAdapterApartados" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
                [columns]="columnsApartados" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false"
                [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true"
                [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true" [editable]="false" [groupable]="true"
                (onRowclick)="onRowSelectApartados($event)">
            </jqxGrid>
            <div style="float: left; margin-top: 10px; clear: both;">
                <jqxButton style="float: left;" [width]='100' [height]='26' [theme]="environment.tema"
                    [imgSrc]='"/assets/images/mas.png"' (onClick)="onNuevo()">
                    Nuevo
                </jqxButton>
                <jqxButton *ngIf="apartadoSelec && apartadoSelec.Nombre" style="float: left; margin-left: 10px;"
                    [width]='100' [height]='26' [theme]="environment.tema" [imgSrc]='"/assets/images/borrar.png"'
                    (onClick)="onBorrar()">
                    Borrar
                </jqxButton>
            </div>
        </div>

        <div *ngIf="apartadoSelec" class="col-3">
            <div style="float: left; margin-top: 40%; width: 100%;">
                <h6 *ngIf="!apartadoSelec.Id || apartadoSelec.Id < 1" style="float: right; color: red; font: bold;">
                    (Nuevo)
                </h6>
                <div style="margin-top: 0px;">
                    <span>Nombre
                        <span style="color: red; font: bold;">*</span>
                    </span>
                    <jqxInput #ebNombre [width]="'100%'" [height]="25">
                    </jqxInput>
                </div>
                <div style="margin-top: 8px;">
                    <span>Acrónimo
                        <span style="color: red; font: bold;">*</span>
                    </span>
                    <jqxInput #ebAcronimo [width]="'100%'" [height]="25">
                    </jqxInput>
                </div>
                <div style="margin-top: 8px;">
                    <span>Subapartado</span>
                    <jqxInput #ebSubApartado [width]="'100%'" [height]="25">
                    </jqxInput>
                </div>
                <div style="margin-top: 8px;">
                    <span>Observaciones</span>
                    <jqxInput #ebObservaciones [width]="'100%'" [height]="25">
                    </jqxInput>
                </div>
            </div>

            <div style="float: left; margin-top: 25px; clear: both;">
                <jqxButton style="float: left;" [width]='100' [height]='26' [theme]="environment.tema"
                    [imgSrc]='"/assets/images/save.png"' (onClick)="onGuardar()">
                    Guardar
                </jqxButton>
            </div>
        </div>

    </div>

</div>